import { Injectable } from "@angular/core";
import { BehaviorSubject, map } from "rxjs";
import { SessionService } from "../session/session.service";
import {
  IChangePasswordPayload,
  IChangePasswordResponse,
  IForgotPassword_Request,
  IForgotPassword_Response,
  ILoginApiResponse,
  ILoginUser_Request,
  IRegisterUser_Request,
  IResetPassword_Request,
  IResetPassword_Response,
  IUserEntity,
  IUserLogin,
  IVerifyResetCode_Request,
  IVerifyResetCode_Response,
} from "./account.model";
import { ApiService } from "../api/api.service";
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class AccountService {

  constructor(
    private apiService: ApiService,
    private sessionService: SessionService
  ) {}

  private readonly baseURL = environment.baseUrl;
  private readonly endpoint = "auth";
  public currentUserSource = new BehaviorSubject<IUserLogin | null>(
    this.getUserFromStorage()
  );
  public currentUser$ = this.currentUserSource.asObservable();

  private getUserFromStorage(): IUserLogin | null {
    try {
      const userString = localStorage.getItem("user");
      if (userString) {
        return JSON.parse(userString);
      }
    } catch (error) {
      console.error("Error parsing user from localStorage:", error);
      localStorage.removeItem("user");
    }
    return null;
  }

  login(model: ILoginUser_Request, rememberMe: boolean) {
    return this.apiService.post<ILoginUser_Request, ILoginApiResponse>({
      Url: `dating/${this.endpoint}/login`,
      Body: model
    })
      .pipe(
        map(response => {
          if (response) {
            localStorage.setItem("user", JSON.stringify(response.data));
            this.currentUserSource.next({
              firstName: response.data.firstName,
              role: response.data.role,
              token: response.auth.token,
              uuidv4Id: response.data.uuidv4Id
            });
            if (response.auth && response.auth.token) {
              try {
                this.sessionService.setSession(
                  response.auth.token,
                  response.data,
                  rememberMe
                );
              } catch (err) {
                console.warn("Unable to set session via SessionService:", err);
              }
            }
          }
          return response;
        })
      );
  }

  forgot(model: IForgotPassword_Request) {
    return this.apiService.post<IForgotPassword_Request, IForgotPassword_Response>({
      Url: "dating/auth/forgot-password",
      Body: model
    });
  }

  verifyResetCode(req: IVerifyResetCode_Request) {
    return this.apiService.post<IVerifyResetCode_Request, IVerifyResetCode_Response>({
      Url: "dating/auth/verify-reset-code",
      Body: req
    });
  }

  resetPassword(req: IResetPassword_Request) {
    return this.apiService.post< IResetPassword_Request, IResetPassword_Response>({
      Url: "dating/auth/reset-password",
      Body: req
    });
  }

  onSubmitForm(model: IRegisterUser_Request) {
    return this.apiService
      .post< IRegisterUser_Request, IUserLogin>({
        Url: `${this.endpoint}/register`,
        Body: model
      })
      .pipe(
        map((response) => {
          if (response) {
            localStorage.setItem("user", JSON.stringify(response));
            this.currentUserSource.next({
              firstName: response.data.firstName,
              role: response.data.role,
              token: response.auth.token
            });
          }
          return response;
        })
      );
  }

  UpdateUser(user: IUserEntity) {
    return this.apiService.put<IUserEntity, IUserEntity>({
      Url: `account`,
      Body: user
    });
  }


  setCurrentUser(user: IUserLogin) {
    this.currentUserSource.next(user);
  }

  refreshToken(token: string) {
    return this.apiService.post<{ refreshToken: string }, any>({
      Url: "dating/auth/refresh",
      Body: { refreshToken: token }
    });
  }

  logout() {
    localStorage.removeItem("user");
    this.currentUserSource.next(null);
  }

   changePassword(payload: IChangePasswordPayload) {
    return this.apiService.put<IChangePasswordPayload,IChangePasswordResponse>({
      Url : `dating/auth/change-password`,
      Body : payload

    });
    
  }
}
